import React from "react";
import { AlertComponent } from "./AlertComponent";
const ValidationMessageComponent = ({
  feedbackLog
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlertComponent, {
    type: "warning",
    messages: feedbackLog.map(f => f.error),
    title: ""
  }));
};
export { ValidationMessageComponent };